import { createAction } from 'redux-actions'
import { actionCreators as api } from 'reduxBits/api'

const prefix = 'AdWatchesCount plugin:'

export const RECEIVE_AD_WATCHES_COUNT = `${prefix} Receive ad watches count`

const receiveAdWatchesCount = createAction(RECEIVE_AD_WATCHES_COUNT)

export const fetchAdWatchesNewCount = () => async (dispatch) => {
  const baseUrl = `saved/v2/searches_new`
  const response = await dispatch(api.fetch(baseUrl))

  if (response.ok) {
    return dispatch(receiveAdWatchesCount(response.textOrJson.newCount))
  }
  return ''
}
